import { render } from "./LegacyIcon.vue?vue&type=template&id=b0bfb14e&scoped=true&ts=true"
import script from "./LegacyIcon.vue?vue&type=script&lang=ts"
export * from "./LegacyIcon.vue?vue&type=script&lang=ts"

import "./LegacyIcon.vue?vue&type=style&index=0&id=b0bfb14e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/legacy_vue_store/legacy_vue_store/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0bfb14e"]])

export default __exports__